import { jsx as _jsx } from "react/jsx-runtime";
/* Generated file. Do not modify. */
import { createElement } from 'react';
import { IconSvg } from '../../icons/IconSvg.js';
export const H1Icon = (props) => createElement(IconSvg, {
    ...props,
    viewBox: "0 0 24 24"
}, _jsx("path", { d: "M1.5 3V11.75H10.5V3H12V21H10.5V13.25H1.5V21H0V3H1.5Z", fill: "currentColor" }), _jsx("path", { d: "M19.4408 9H20.75V19.5H23V21H17V19.5H19.25V11.5274L17.5694 13.4881L16.4306 12.5119L19.4408 9Z", fill: "currentColor" }));
//# sourceMappingURL=H1Icon.js.map